import TranslationInput from '../ItemEditor/TranslationInput';
import BulletListEditor from '../ItemEditor/BulletListEditor';
import { emptyTranslation, normalizeTranslation } from '../../utils/translationUtils';

const TextSectionFields = ({ section, onChange }) => (
  <TranslationInput
    label="Text"
    value={section.text}
    onChange={(lang, val) => onChange({ ...section, text: { ...section.text, [lang]: val } })}
    textarea
  />
);

const BulletsSectionFields = ({ section, onChange }) => (
  <BulletListEditor
    type="string"
    bullets={section.bullets}
    onChange={(bullets) => onChange({ ...section, bullets })}
  />
);

export const BLOG_SECTION_TYPES = {
  text: {
    label: 'Text',
    icon: 'notes',
    Fields: TextSectionFields,
    createContent: () => ({ text: emptyTranslation() }),
    normalizeContent: (raw) => ({ text: normalizeTranslation(raw.text) }),
    isComplete: (section) => !!section.text.en.trim(),
  },
  bullets: {
    label: 'Bullet points',
    icon: 'format_list_bulleted',
    Fields: BulletsSectionFields,
    createContent: () => ({ bullets: [emptyTranslation()] }),
    normalizeContent: (raw) => ({ bullets: (raw.bullets ?? []).map(normalizeTranslation) }),
    isComplete: (section) => section.bullets.length > 0 && section.bullets.every(bullet => !!bullet.en.trim()),
  },
};

export const createBlogSection = (type) => ({
  type,
  heading: emptyTranslation(),
  ...BLOG_SECTION_TYPES[type].createContent(),
});

export const normalizeBlogSection = (raw) => ({
  type: raw.type,
  heading: normalizeTranslation(raw.heading),
  ...BLOG_SECTION_TYPES[raw.type].normalizeContent(raw),
});

export const isKnownBlogSection = (raw) => raw.type in BLOG_SECTION_TYPES;
